import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useTheme } from '../contexts/ThemeContext';
import './TermsOfUse.css';

const TermsOfUse = ({ isOpen, onClose }) => {
  const { isDarkMode } = useTheme();

  if (!isOpen) return null;

  const themeStyles = {
    modal: {
      background: isDarkMode 
        ? 'rgba(0, 0, 0, 0.8)' 
        : 'rgba(0, 0, 0, 0.5)'
    },
    content: {
      background: isDarkMode 
        ? 'linear-gradient(145deg, #151e30 0%, #121a2c 100%)'
        : 'linear-gradient(145deg, #ffffff 0%, #f5f9ff 100%)',
      color: isDarkMode ? '#ffffff' : '#2c3e50',
      boxShadow: isDarkMode 
        ? '0 10px 30px rgba(0, 0, 0, 0.5)' 
        : '0 10px 30px rgba(0, 0, 0, 0.2)'
    },
    text: {
      primary: isDarkMode ? '#ffffff' : '#2c3e50',
      secondary: isDarkMode ? '#e1e9ff' : 'rgba(44, 62, 80, 0.8)'
    },
    closeButton: {
      color: isDarkMode ? '#ffffff' : '#2c3e50',
      background: 'transparent',
      border: 'none',
      cursor: 'pointer'
    }
  };

  return (
    <div className="terms-modal-overlay" style={themeStyles.modal} onClick={onClose}>
      <div className="terms-modal-content" style={themeStyles.content} onClick={(e) => e.stopPropagation()}>
        <div className="terms-modal-header">
          <h2 style={{ color: themeStyles.text.primary, margin: 0 }}>Terms of Use</h2>
          <button 
            className="terms-close-button" 
            onClick={onClose}
            style={themeStyles.closeButton}
          >
            <FontAwesomeIcon icon={faTimes} size="lg" />
          </button>
        </div>
        
        <div className="terms-modal-body">
          <div style={{ color: themeStyles.text.secondary, lineHeight: '1.6' }}>
            <p><strong>Effective Date:</strong> July 20, 2025</p>
            <p><strong>Last Updated:</strong> July 21, 2025</p>
            
            <p>PLEASE READ THESE TERMS OF USE ("Terms") CAREFULLY. BY ACCESSING OR USING THE EXAMFLIP WEBSITE (HTTPS://WWW.EXAMFLIP.COM) OR ANY RELATED MOBILE APPLICATIONS, CONTENT, FEATURES, OR SERVICES (COLLECTIVELY, THE "Service"), YOU ("you", "your", or "User") AGREE TO BE BOUND BY THESE TERMS.</p>

            <h3 style={{ color: themeStyles.text.primary, marginTop: '25px' }}>1. CONTRACTING PARTIES</h3>
            <p>1.1 These Terms are entered into by and between ExamFlip and any individual who accesses or uses the Service, whether under an individual subscription or under an institutional subscription purchased by a school, residency program, or other organization ("Institutional Subscriber").</p>
            <p>1.2 If you access the Service on behalf of an Institution, you represent that you have authority to bind that Institution to these Terms, in which case "you" and "your" will also refer to that Institution.</p>

            <h3 style={{ color: themeStyles.text.primary }}>2. ACCEPTANCE; CHANGES</h3>
            <p>2.1 By creating an account, clicking "I Agree," or otherwise indicating acceptance, you acknowledge that you have read, understood, and agree to be bound by these Terms, our Privacy Policy, and any additional terms referenced herein.</p>
            <p>2.2 We may update these Terms from time to time. Material changes will be posted on the Site or communicated to you by email at least 30 days before they take effect.</p>

            <h3 style={{ color: themeStyles.text.primary }}>3. ELIGIBILITY AND REGISTRATION</h3>
            <p>3.1 You must be at least 18 years old and legally capable of entering into binding contracts to use the Service.</p>
            <p>3.2 You agree to provide accurate, current, and complete information during registration and to keep your account information up‑to‑date.</p>
            <p>3.3 You are responsible for safeguarding your password and for all activities that occur under your account.</p>

            <h3 style={{ color: themeStyles.text.primary }}>4. SCOPE OF SERVICE</h3>
            <p>4.1 ExamFlip is an online educational platform focused exclusively on United States Medical Licensing Examination (USMLE) content for CBSE, Step 1, and Step 2 examinations ("Exam Content").</p>
            <p>4.2 The Service includes question banks, analytics dashboards, artificial‑intelligence ("AI")‑powered study tools (including chat‑based question support), and simulated Objective Structured Clinical Examination ("OSCE") scenarios generated in part by AI technologies.</p>

            <h3 style={{ color: themeStyles.text.primary }}>5. AI FEATURES & DISCLAIMERS</h3>
            <p>5.1 <strong>AI Outputs:</strong> The Service uses large‑language models, machine‑learning algorithms, and other AI techniques to generate, curate, or enhance questions, explanations, chat responses, and OSCE simulations ("AI Outputs").</p>
            <p>5.2 <strong>No Guarantee of Accuracy:</strong> AI Outputs are probabilistic and may contain errors, omissions, outdated information, or clinically inappropriate suggestions.</p>
            <p>5.3 <strong>Verification Required:</strong> You agree to independently verify all AI Outputs against authoritative primary sources and to exercise professional judgment before relying on any information in a clinical setting.</p>

            <h3 style={{ color: themeStyles.text.primary }}>6. EDUCATIONAL PURPOSE ONLY; NO MEDICAL ADVICE</h3>
            <p>6.1 The Service and all content are intended solely for educational, informational, and exam‑preparation purposes. THEY DO NOT CONSTITUTE MEDICAL, LEGAL, OR OTHER PROFESSIONAL ADVICE, DIAGNOSIS, OR TREATMENT.</p>

            <h3 style={{ color: themeStyles.text.primary }}>7. SUBSCRIPTIONS, FEES & REFUND POLICY</h3>
            <p>7.1 <strong>Subscription Plans:</strong> Access to the Service requires the purchase of a subscription plan, unless provided through an Institutional Subscriber.</p>
            <p>7.2 <strong>Payment:</strong> You authorize ExamFlip to charge your selected payment method for all subscription fees and applicable taxes. Fees are payable in advance and are non‑refundable except as expressly stated.</p>
            <p>7.3 <strong>Satisfaction Guarantee:</strong> If, within the first 7 calendar days of your initial purchase, you have completed fewer than 25 questions, you may request a full refund.</p>

            <h3 style={{ color: themeStyles.text.primary }}>8. LIMITATION OF LIABILITY</h3>
            <p>8.1 TO THE MAXIMUM EXTENT PERMITTED BY LAW, EXAMFLIP'S TOTAL LIABILITY TO YOU FOR ALL CLAIMS SHALL NOT EXCEED THE AMOUNT PAID BY YOU TO EXAMFLIP FOR THE SERVICE IN THE TWELVE (12) MONTHS PRECEDING THE EVENT GIVING RISE TO THE CLAIM.</p>

            <h3 style={{ color: themeStyles.text.primary }}>9. CONTACT INFORMATION</h3>
            <p>Exirsoft Technology (dba ExamFlip.com)<br />
            3902 Los Olivos Ln<br />
            La Cresenta, CA 91214, USA<br />
            Email: support@examflip.com</p>

            <p style={{ marginTop: '30px', fontSize: '0.9em', color: themeStyles.text.secondary }}>
              <em>This is a summary of key provisions. The complete Terms of Use document contains additional important details and provisions that govern your use of the Service.</em>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;
